import React, { useState } from "react";
import axios from "axios";
import { Button, Modal, TextInput } from "@opendate-app/setlist";

import { toastSuccess, toastError } from "../../../shared/toastHelper";

// The server returns the specific template problem as a 422 with { errors: [...] }.
// Those messages tell the user what to change, so prefer them over the generic copy.
// A 5xx is an unhandled failure, not a template problem the user can act on.
export const sendTestErrorMessage = (error) => {
  const fallback = "Could not send test email, please try again";
  const status = error?.response?.status;
  const errors = error?.response?.data?.errors;

  if (status >= 500 || !errors) {
    return fallback;
  }

  if (Array.isArray(errors)) {
    return errors.length ? errors.join(", ") : fallback;
  }

  return String(errors);
};

const SendTestOverlay = ({
  templatableContext,
}) => {
  const {
    testModalOpen,
    setTestModalOpen,
    user,
    template,
    sampleData,
    csrfToken,
    beefreeTemplateId,
    team,
    sampleFanId,
    subject,
    sendDomain,
    preheader,
    venueOwnership,
    isAdminBlueprint,
  } = templatableContext();

  const [testInputValue, setTestInputValue] = useState(user.email);

  const sendTest = (emails) => {
    setTestModalOpen(false);
    axios.defaults.headers.common["X-CSRF-TOKEN"] = csrfToken;

    const url = isAdminBlueprint
      ? `/admin/beefree_templates/${beefreeTemplateId}/test`
      : `/teams/${team.id}/beefree_templates/${beefreeTemplateId}/test`;

    const payload = isAdminBlueprint
      ? {
          emails: emails,
          template: template,
          liquid_data: sampleData,
        }
      : {
          emails: emails,
          template: template,
          liquid_data: sampleData,
          fan_id: sampleFanId,
          subject: subject,
          send_domain_id: sendDomain?.id,
          preheader: preheader,
          venue_ownership_id: venueOwnership?.id,
        };
    
    axios.post(url, payload)
      .then(() => {
        toastSuccess("Test email sent successfully");
      })
      .catch((error) => {
        toastError(sendTestErrorMessage(error));
      });
  };

  const close = () => setTestModalOpen(false);

  return (
    <Modal
      open={testModalOpen}
      onClose={close}
      title="Test Email"
      description="Send a test email to..."
      footer={(
        <>
          <Button variant="secondary" onClick={close}>Cancel</Button>
          <Button variant="primary" disabled={!testInputValue} onClick={() => sendTest(testInputValue)}>
            Send Test
          </Button>
        </>
      )}
    >
      <TextInput
        aria-label="Test email recipients"
        placeholder="Example: b@xyz.com, a+test@xyz.com"
        value={testInputValue}
        onChange={(e) => setTestInputValue(e.target.value)}
      />
    </Modal>
  );
};

export default SendTestOverlay;
